import {Injectable} from '@angular/core';
import {Router, Routes, ActivatedRoute} from '@angular/router';
import * as _ from 'lodash';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Constants } from '../../../app.constant';
import { constants } from 'os';

@Injectable()
export class BaMenuService {
  menuItems = new BehaviorSubject<any[]>([]); 
  protected _currentMenuItem = {};
  protected _cmsResourceList = [];
  protected _adminResourceList = [];
  protected _deviceResourceList = [];
  protected _reportResourceList = [];

  constructor(
	  private _router:Router,
    private _route: ActivatedRoute
  ) { }

  /**
   * Updates the routes in the menu
   *
   * @param {Routes} routes Type compatible with app.menu.ts
   */
  public updateMenuByRoutes(routes: Routes) {
    let convertedRoutes = this.convertRoutesToMenus(_.cloneDeep(routes));
    this.menuItems.next(convertedRoutes);
  }

  public convertRoutesToMenus(routes:Routes):any[] {
    let items = this._convertArrayToItems(routes);
    return this._skipEmpty(items);
  }

  public getCurrentItem():any {
    return this._currentMenuItem;
  }

  public selectMenuItem(menuItems:any[]):any[] {
    let items = [];
    menuItems.forEach((item) => {
      this._selectItem(item);

      if (item.selected) {
        this._currentMenuItem = item;
      }
      
      if (item.children && item.children.length > 0) {
        item.children = this.selectMenuItem(item.children);
      }
      items.push(item);
    });
    return items;
  }

  protected _skipEmpty(items:any[]):any[] {
    let menu = [];
    items.forEach((item) => {
      let menuItem;
      if (item.skip) {
        if (item.children && item.children.length > 0) {
          menuItem = item.children;
        }
      } else {
        menuItem = item;
      }

      if (menuItem) {
        menu.push(menuItem);
      }
    });

    return [].concat.apply([], menu);
  }

  protected _convertArrayToItems(routes:any[], parent?:any):any[] {
    let items = [];
    routes.forEach((route) => {
      items.push(this._convertObjectToItem(route, parent));
    });
    return items;
  }

  protected _convertObjectToItem(object, parent?:any):any {
    let item:any = {};
    if (object.data && object.data.menu) {
      // this is a menu object
      item = object.data.menu;
      item.route = object;
      delete item.route.data.menu;
    } else {
      item.route = object;
      item.skip = true;
    }

	  // console.log('object.path', object.path, ' || this._router > ', this._router.config[6].children);
	  this._router.config.forEach((res:any) => {
      if (res.path == 'pages') {
        _.forEach(res.children, (ad) => {
          if (ad.path == 'admin') {
            this._adminResourceList = ad.data.resource;
          }
          if (ad.path == 'cms') {
            this._cmsResourceList = ad.data.resource;
          }
          if (ad.path == 'device') {
            this._deviceResourceList = ad.data.resource;
          }
          if (ad.path == 'reports') {
            this._reportResourceList = ad.data.resource;
          }
        });
      }
	  });

    if (object.path == 'dashboard') {
      let customerInfo = Constants.CurrentCustomerInfomations();
      if(customerInfo != null){
        if(customerInfo.isCustomerOnboarded){
          item.hidden = false;
        }else{
          item.hidden = true;
        }
      }
    }
    if (object.path == 'qmsdashboard') {
      let customerInfo = Constants.CurrentCustomerInfomations();
      if(customerInfo != null){
        if(customerInfo.isQMSEnabled){
          item.hidden = false;
        }else{
          item.hidden = true;
        }
      }
    }
	  if (object.path == 'admin') {
		  let val = Constants.IsMenuEnable(object.path, this._adminResourceList);
      item.hidden = (!val);
      let customerInfo = Constants.CurrentCustomerInfomations();
      if(customerInfo != null){
        if(customerInfo.isCustomerOnboarded){
          item.expanded = false;
        }else{
          item.expanded = true;
        }
      }      
    }
	  if (object.path == 'list-customer') {
		  let resourceInfo = ['CUSTOMER'];
		  let val = Constants.IsMenuEnable(object.path, resourceInfo);
	  	item.hidden = (!val);
    }
    // if (object.path == 'pending-approval-list-customer') {
		//   let resourceInfo = ['']; // to be Filled
		//   let val = Constants.IsMenuEnable(object.path, resourceInfo);
	  // 	item.hidden = (!val);
	  // }
	  if (object.path == 'list-roles') {
      let resourceInfo = ['ROLE'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      if (!Constants.CurrentCustomerInfomations('customerId') && Constants.CurrentUserInfomations('userType') == "CUST_REP_ADMIN") {
        item.hidden = true;
      } else {
        item.hidden = (!val);
      }
	  }
	  if (object.path == 'list-user') {
      let resourceInfo = ['USER'];
      let rol: boolean = Constants.IsMenuEnable(object.path, resourceInfo);
      let spcl = Constants.CurrentCustomerInfomations('isCustomerOnboarded');
      if (!spcl && spcl != null) {
        rol = spcl;
      }
      if (!Constants.CurrentCustomerInfomations('customerId') && Constants.CurrentUserInfomations('userType') == "CUST_REP_ADMIN") {
        item.hidden = true;
      } else {
        item.hidden = !rol;
      }
	  }
	  if (object.path == 'organization-settings') {
      let resourceInfo = ['CUSTOMER_SETUP'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
	  	item.hidden = (!val);
	  }

    if (object.path == 'list-onpremise' || object.path == 'premises') {
      let resourceInfo = ['ON_PREMISES'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
    }
    if (object.path == 'car-configurator') {
      let resourceInfo = ['TPA_REPORTS'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      // item.hidden = (!val);
      if (Constants.Var.tpaChildItems.length>0) {
        item.hidden = false;     
      }else{
        item.hidden = true;
      }
    }
	  
	  if (object.path == 'cms') {
      let val = Constants.setCmsForPanasonicMembers('userType', 'canPansonicAdminAccessCMS', 'isCustomerOnboarded', object.path, this._cmsResourceList);
      item.hidden = (val);
	  }
	  if (object.path == 'media-library') {
      let resourceInfo = ['CONTENT'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
	  }
	  if (object.path == 'template') {
      let resourceInfo = ['TEMPLATE'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
	  }
	  if (object.path == 'campaign-list') {
      let resourceInfo = ['LAYOUT'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
	  }
	  if (object.path == 'campaign-string-list') {
      let resourceInfo = ['LAYOUT_GROUP'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
	  }
	  if (object.path == 'planogram') {
      let resourceInfo = ['PLANOGRAM'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
	  }
	  
	  if (object.path == 'device') {
      let val = Constants.setDeviceForPanasonicAdmin('isCustomerOnboarded', object.path, this._deviceResourceList);
      item.hidden = (val);
	  }
	  if (object.path == 'register-device') {
      let resourceInfo = ['DEVICE_ONBOARD'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
	  }
	  if (object.path == 'device-info') {
      let resourceInfo = ['DEVICE', 'DEVICE_GROUP'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
	  }
	  if (object.path == 'device-group') {
      let resourceInfo = ['DEVICE_GROUP'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
	  }
	  if (object.path == 'devices-config') {
      let resourceInfo = ['CUSTOMER_DEVICE_CONFIG']; 
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
    }
    if (object.path == 'resolution-list') {
      let resourceInfo = ['ASPECT_RATIO']; 
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      if(val && Constants.CurrentCustomerInfomations("customerType") == 'ADVANCED')
        item.hidden = false;
      else
        item.hidden = true;
    }
    
    if (object.path == 'reports') {
      let resourceInfo = ['REPORTS']; 
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      let customerInfo = Constants.CurrentCustomerInfomations();
      if (customerInfo == null) {
        item.hidden = (!val);
      }
      else {
        if(customerInfo.isCustomerOnboarded && val && customerInfo.customerType != 'BASIC'){
          item.hidden = false;
        }
        else {
          item.hidden = true;
        }
      }
    }
    if (object.path == 'tpa-list') {
      let resourceInfo = ['TPA'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      item.hidden = (!val);
    }
    if (object.path == 'tpa-reports') {
      let resourceInfo = ['TPA_REPORTS'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      // item.hidden = (!val);
      if (Constants.Var.shouldShowTpaReports) {
        item.hidden = false;     
      }else{
        item.hidden = true;
      }
    }
    if (object.path == 'tpa-content-playback') {
      let resourceInfo = ['TPA_REPORTS'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      // item.hidden = (!val);
      if (Constants.Var.shouldShowTpaReports) {
        item.hidden = false;    
      }else{
        item.hidden = true;
      }
    }
    if(object.path == 'pdn-report'){
      // let resourceInfo = ['reports'];
      if(Constants.PDNConfig('isPDNEnabled') == true && (_.isNull(Constants.CurrentCustomerInfomations("customerId"))) ? true : Constants.CurrentCustomerInfomations('isAdvertisementEnabled') == true){
        item.hidden = false;
      }else{
        item.hidden = true;
      }
    }
    if(object.path == 'dg-dashboard'){      
      let val = Constants.IsMenuEnable(object.path, ['FA_REPORTS']);
      if(Constants.CurrentEnvironmentProperties('enableDemographic') == true && Constants.CurrentCustomerInfomations('enableDemographic') == true && val){
        item.hidden = false;
      }else{
        item.hidden = true;
      }
    }

    if(object.path == 'fa-reports'){
      let resourceInfo = ['FA_REPORTS'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      if(Constants.CurrentEnvironmentProperties('enableDemographic') == true && Constants.CurrentCustomerInfomations('enableDemographic') == true && val){
        item.hidden = false;
      }else{
        item.hidden = true;
      }
    } 
    
    if(object.path == 'pending-approval-list-customer'){
      // let resourceInfo = ['reports']; 
      if(Constants.CurrentEnvironmentProperties('enableDesktopRegistration') == true){
        item.hidden = false;
      }else{
        item.hidden = true;
      }
    }
    
    if ([
      'content-current-download', 
      'content-playback', 
      'planogram-reports', 
      'content-previous-download', 
      'statistics-report'
    ].indexOf(object.path) >= 0) {
      let customerInfo = Constants.CurrentCustomerInfomations();
      let userType = Constants.CurrentUserInfomations('userType');
      if (customerInfo.canPansonicAdminAccessCMS) {
        item.hidden = false;
      }
      else {
        if ([
          'SUPER', 
          'CUST_REP_ADMIN'
        ].indexOf(userType)<0) {
          item.hidden = false;
        }
        else {
          item.hidden = true;
        }
      }
    }
    
    
    if (object.path == 'dg-dashboard') {
      let resourceInfo = ['FA_REPORTS'];
      let accessDemographic = Constants.CurrentCustomerInfomations('enableDemographic');
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      // item.hidden = (!val);
      if (accessDemographic && val) {
        item.hidden = false;    
      }else{
        item.hidden = true;
      }
    }

    if (object.path == 'demographic-dashboard') {
      //let val = Constants.setCmsForPanasonicMembers('userType', 'canPansonicAdminAccessCMS', 'isCustomerOnboarded', object.path, this._cmsResourceList);
      let customerInfo = Constants.CurrentCustomerInfomations();
      let userType = Constants.CurrentUserInfomations('userType');
      let accessDemographic = Constants.CurrentCustomerInfomations('enableDemographic');
      let resourceInfo = ['LAYOUT'];
      let val = Constants.IsMenuEnable(object.path, resourceInfo);
      let resourceInfoRule = ['FA_RULE_ENGINE'];
      let valRule = Constants.IsMenuEnable(object.path, resourceInfoRule);
      if(accessDemographic && val && valRule)
      {
        if (customerInfo.canPansonicAdminAccessCMS) {
          /*if ([
            'SUPER', 
            'CUST_REP_ADMIN'
          ].indexOf(userType)<0) {
            item.hidden = false;
          }
          else {
            item.hidden = true;
          }*/
          item.hidden = false;
        }
        else {
          if ([
            'SUPER', 
            'CUST_REP_ADMIN'
          ].indexOf(userType)<0) {
            item.hidden = false;
          }
          else {
            item.hidden = true;
          }
          //item.hidden = true;
        }
      }else {
        item.hidden = true;
      }
      
	  }

    // We have to collect all paths to correctly build the url then.
    if (Array.isArray(item.route.path)) {
      item.route.paths = item.route.path;
    } else {
      item.route.paths = parent && parent.route && parent.route.paths ? parent.route.paths.slice(0) : ['/'];
      if (!!item.route.path) item.route.paths.push(item.route.path);
    }

    if (object.children && object.children.length > 0) {
      item.children = this._convertArrayToItems(object.children, item);
    }

    let prepared = this._prepareItem(item);

    // if current item is selected or expanded - then parent is expanded too
    if ((prepared.selected || prepared.expanded) && parent) {
      parent.expanded = true;
    }

    return prepared;
  }

  protected _prepareItem(object:any):any {
    if (!object.skip) {
      object.target = object.target || '';
      object.pathMatch = object.pathMatch  || 'full';
      return this._selectItem(object);
    }
    return object;
  }

  protected _selectItem(object:any):any {    
    if(!object.menuId){
      if(object.route.path == 'dg-dashboard'){
        object.route.paths[2] = object.route.paths[3] = 'demographic-dashboard';
      }
      object.selected = this._router.isActive(this._router.createUrlTree(object.route.paths), object.pathMatch === 'full');
    }else{
      object.selected = this._router.isActive(this._router.createUrlTree(object.route.paths), false);
    }
    return object;
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/baMenu/baMenu.service.ts